import type { AccordionProps } from '../Accordion';

export interface FaqAccordionData {}

export interface FaqAccordionProps extends FaqAccordionData, Pick<AccordionProps, 'tabs'> {}
